module.exports = __webpack_public_path__ + "static/media/AMAZON.eea74231.png";